import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {findResourceByResourceTypeInPath} from '@toolify/client/src/modules/activity/singletons/findResourceByResourceTypeInPath'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {i18n} from '@toolify/client/src/setup/i18n'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

const {t} = i18n.global

export class UserAssignedToDatabaseItemNotificationStrategy extends DefaultNotificationStrategy<NotificationType.UserAssignedToDatabaseItem> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.UserAssignedToDatabaseItem>, authorNick: string): IBrowserNotification {
    const databaseItem = findResourceByResourceTypeInPath(notification.resourcePath, ResourceType.DatabaseItem)
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: ENV.AppBrandingName,
      body: t('notifications.browserNotifications.userAssignedToDatabaseItem', {
        author: authorNick,
        item: databaseItem?.name || t('general.noTitle'),
      }),
    }
  }

  getAffectedFilterTypes(notification: INotificationResponseInstance<NotificationType.UserAssignedToDatabaseItem>): NotificationFilterType[] {
    return [
      NotificationFilterType.All,
      NotificationFilterType.Unread,
      NotificationFilterType.AssignedToMe,
    ]
  }
}
